import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import { rules, Form, Input, Select } from 'react-validation/lib/build/validation.rc';
import { Row, Col } from 'react-bootstrap';
import { initRules } from 'utils/ValidateUtils';
import { getYearsSince, getMonthNames } from 'utils/DateUtils.js';
import USStates from 'constants/USStates';
import EmailPreferenceTypes from 'constants/EmailPreferenceTypes';

class MemberForm extends Component {
  static propTypes = {
    emailList: PropTypes.array,
    member: PropTypes.object,
    btnText: PropTypes.string,
    onSubmit: PropTypes.func
  }

  static defaultProps = {
    member: {}
  }

  state = {
    preference: null,
    announcement: this.props.member.receiveAnnouncements || false,
    offer: this.props.member.receiveOffers || false,
    isFormChanged: false
  }

  componentWillMount() {
    _.assign(rules, initRules((message) => <span className="Form-control-errorMessage">{message}</span>));
  }

  _onSubmitForm(event) {
    event.preventDefault();

    if (this._isFormValid()) {
      const {
        onSubmit
      } = this.props;

      const {
        preference = [],
        announcement: receiveAnnouncements = false,
        offer: receiveOffers = false
      } = this.state;

      const { components } = this.form;

      const formData = _.mapValues(components, 'state.value');
      const { year, month, day } = formData;

      _.assign(formData, {
        receiveOffers,
        receiveAnnouncements
      });

      if (year && month && day) {
        formData.dateOfBirth = `\/Date(${new Date(year, month - 1, day).getTime()})\/`;
      }

      const memberData = _.mapKeys(_.pick(formData, [
        'emailAddress',
        'password',
        'username',
        'firstName',
        'lastName',
        'dateOfBirth',
        'address',
        'city',
        'state',
        'zipcode',
        'phoneNumber',
        'receiveOffers',
        'receiveAnnouncements'
      ]), (value, key) => _.toLower(key));

      onSubmit(memberData, preference || []);
    }
  }

  _isFormValid() {
    return _.isEmpty(this.form.validateAll());
  }

  _onCheckBoxChange(name) {
    this.setState({
      [name]: !this.state[name]
    });
  }

  _onPreferenceCheckBoxChange(newValue) {
    this.setState({
      preference: newValue
    });
  }

  _onFormChange() {
    this.setState({
      isFormChanged: true
    });
  }

  render() {
    const {
      member,
      emailList,
      btnText
    } = this.props;

    const {
      emailAddress = '',
      username = '',
      firstName = '',
      lastName = '',
      month = '',
      day = '',
      year = '',
      address = '',
      city = '',
      state = 0,
      zipcode = '',
      phoneNumber = '',
      preference: emailPreference = []
    } = member;

    const isProfile = !_.isEmpty(member);

    const {
      preference,
      announcement,
      offer,
      isFormChanged
    } = this.state;

    const smallColProp = {
      sm: 4,
      xs: 12
    };
    const mediumColProp = {
      sm: 6,
      xs: 12
    };
    const largeColProp = {
      xs: 12
    };

    return (
      <Form className="Form" ref={form => this.form = form} onSubmit={(event) => this._onSubmitForm(event)} onChange={() => this._onFormChange()}>
        <Row>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['required', 'email']}
              value={emailAddress}
              name="emailAddress"
              errorClassName="Form-control-input--error"
              placeholder="email *"
            />
          </Col>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['required', 'email', 'confirmEmail']}
              value={emailAddress}
              name="confirmEmail"
              errorClassName="Form-control-input--error"
              placeholder="re-enter email *"
            />
          </Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['required']}
              value={username}
              name="username"
              errorClassName="Form-control-input--error"
              placeholder="username *"
            />
          </Col>
        </Row>
        <Row>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              type="password"
              validations={isProfile ? [] : ['required']}
              value=""
              name="password"
              errorClassName="Form-control-input--error"
              placeholder={isProfile ? 'new password' : 'password *'}
            />
          </Col>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              type="password"
              validations={isProfile ? ['password'] : ['required', 'password']}
              value=""
              name="confirmPassword"
              errorClassName="Form-control-input--error"
              placeholder={isProfile ? 're-enter new password' : 're-enter password *'}
            />
          </Col>
        </Row>
        <Row>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['name']}
              value={firstName}
              name="firstName"
              errorClassName="Form-control-input--error"
              placeholder="first name"
            />
          </Col>
          <Col {...mediumColProp} className="Form-control">
            <Input
              className="Form-control-input"
              validations={['name']}
              value={lastName}
              name="lastName"
              errorClassName="Form-control-input--error"
              placeholder="last name"
            />
          </Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-label">Date of Birth</Col>
          <Col {...smallColProp} className="Form-control">
            <Select className="Form-control-input"
              validations={['birthday']}
              value={month}
              name="month"
              errorClassName="Form-control-input--error"
            >
              <option value="">MONTH</option>
              {
              getMonthNames().map((item, index) => {
                return (
                  <option key={item} value={index + 1}>{item}</option>
                );
              })
            }
            </Select>
          </Col>
          <Col {...smallColProp} className="Form-control">
            <Select
              className="Form-control-input"
              validations={['birthday']}
              value={day}
              name="day"
              errorClassName="Form-control-input--error"
            >
            <option value="">DAY</option>
            {
              _.range(1, 32).map(item => {
                return (
                  <option key={item} value={item}>{item}</option>
                );
              })
            }
            </Select>
          </Col>
          <Col {...smallColProp} className="Form-control">
            <Select className="Form-control-input"
              validations={['birthday']}
              value={year}
              name="year" errorClassName="Form-control-input--error"
            >
            <option value="">YEAR</option>
            {
              getYearsSince().map(item => {
                return (
                  <option key={item} value={item}>{item}</option>
                );
              })
            }
            </Select>
          </Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={[]}
              value={address}
              name="address"
              errorClassName="Form-control-input--error"
              placeholder="street address"
            />
          </Col>
        </Row>
        <Row>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={[]}
              value={city}
              name="city"
              errorClassName="Form-control-input--error"
              placeholder="city"
            />
          </Col>
          <Col {...mediumColProp} className="Form-control">
            <Select className="Form-control-input"
              validations={[]}
              value={state}
              name="state"
              errorClassName="Form-control-input--error"
              >
              <option value="0">STATE</option>
              {
                USStates.map((item, index) => {
                const {
                  name,
                  value
                } = item;
                return (
                  <option key={index} value={value}>{name}</option>
                );
              })
              }
            </Select>
          </Col>
        </Row>
        <Row>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['required', 'zipcode']}
              value={zipcode}
              name="zipcode"
              errorClassName="Form-control-input--error"
              placeholder="zip code *"
            />
          </Col>
          <Col {...mediumColProp} className="Form-control">
            <Input className="Form-control-input"
              validations={['phone']}
              value={phoneNumber}
              name="phoneNumber"
              errorClassName="Form-control-input--error"
              placeholder="phone"
            />
          </Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-label">Email preference</Col>
          <CheckboxGroup
            name="preference"
            value={preference || emailPreference}
            onChange={(newValue) => this._onPreferenceCheckBoxChange(newValue, 'preference')}>
            {
              emailList.map((email, index) => {
                const {
                  displayname = '',
                  emaillisttypes = [],
                  id = ''
                } = email;
                /** Only take HTML ones (Text = 1, SMS = 2, HTML = 4) */
                if (_.indexOf(emaillisttypes, EmailPreferenceTypes.HTML) !== -1) {
                  return (
                    <Col {...largeColProp} key={index} className="Form-control-checkbox">
                      <label><Checkbox value={id}/>{displayname} </label>
                    </Col>
                  );
                } else {
                  return null;
                }
              })
            }

        </CheckboxGroup>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-label">Subscription</Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-control-checkbox">
            <div>
              <label><input type="checkbox" checked={announcement} value="announcement" onChange={() => this._onCheckBoxChange('announcement')}/>
              Yes, I would like to receive new offers and promotions from your site.</label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col {...largeColProp} className="Form-control-checkbox">
            <div>
              <label><input type="checkbox" checked={offer} value="offer" onChange={() => this._onCheckBoxChange('offer')}/>Yes, I would like to receive special offers from your trusted partners.</label>
            </div>
          </Col>
        </Row>
        <div className="Form--footer">
          {!isProfile &&
            <div className="Form-hint">Already have an account? <a href="/login" >Login</a></div>
          }
          <button className="Form-submitBtn" disabled={!isFormChanged}>{btnText}</button>
        </div>
      </Form>
    );
  }
}

export default MemberForm;



// WEBPACK FOOTER //
// ./app/components/membership/MemberForm.js